// extracted by mini-css-extract-plugin
module.exports = {"navContainer":"DesktopNavigation_navContainer__Uxlq5"};